import { render, staticRenderFns } from "./AddPassword.vue?vue&type=template&id=33e13cd2"
import script from "./AddPassword.vue?vue&type=script&lang=js"
export * from "./AddPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports